<template>
  <div>
    <div class="row">
      <div class="col-12 mb-2">
        <div class="row align-items-center text-center">
          <div class="col-12 text-center">
            <button class="btn iconed btn-secondary mx-2" v-b-modal.new-timesheet><i
              class="icon-bd-plus"></i><span>تعریف روزهای کاری</span></button>
            <button class="btn iconed btn-danger mx-2" v-b-modal.delete-timesheet><i
              class="icon-bd-plus"></i><span>حذف روز کاری</span></button>
            <div>
              <date-picker
                v-show=true
                :visibel=true
                :highlight="highlight"
                format="jYYYY-jMM-jDD"
                @input="setDateFromDatePicker"
                ref="datePicker3"
              >
                <slot>
                  <button @click="showTimesheet" class="btn iconed btn-info m-3"><i
                    class="icon-calendar-blank-outline"></i><span>مشاهده تقویم</span></button>
                </slot>
              </date-picker>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="col-lg-12 p-0">-->
      <!--<table class="table table-striped">-->
      <!--<thead>-->
      <!--<tr>-->
      <!--<th scope="col" class="text-center">عملیات</th>-->
      <!--<th scope="col" class="text-center">تاریخ</th>-->
      <!--<th scope="col" class="text-center">ساعت</th>-->
      <!--</tr>-->
      <!--</thead>-->
      <!--<tbody>-->
      <!--<tr v-for="(item, index) of timeSheets">-->
      <!--<td class="text-center">-->
      <!--<button :id="'btn-problem-' + item.id" class="btn btn-secondary ml-2"-->
      <!--@click="editProblemType(item, index)"-->
      <!--data-toggle="tooltip"><i class="icon-bd-pencil"></i>-->
      <!--</button>-->
      <!--<button :id="'btn-delete-' + item.id" class="btn btn-secondary"-->
      <!--@click="onDeleteClicked(item, index)"><i class="icon-bd-delete"></i></button>-->
      <!--</td>-->
      <!--<th scope="row" class="text-center">{{item.dateTime}}</th>-->
      <!--<td class="text-center">{{item.timeOfDay}}</td>-->

      <!--</tr>-->
      <!--</tbody>-->
      <!--</table>-->
      <!--</div>-->





    </div>
    <b-modal
      id="new-timesheet"
      ref="problemTypeModal"
      title="تعریف روزهای کاری"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="input-group col-12">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <i class="icon-calendar-blank-outline"></i>
                <span>تاریخ شروع برنامه</span>
              </div>
            </div>
            <input
              v-show=false
              readonly="readonly"
              v-model="startDate"
              type="text"
              class="form-control"
            >
            <date-picker
              v-show=true
              :disable="disableDates"
              :auto-submit="true"
              format="jYYYY-jMM-jDD"
              @input="setDateFromDatePicker"
              ref="datePicker"
            >
              <slot>
                <input
                  :readonly=true
                  v-model="startDate"
                  class="form-control date-input"
                  @click="toggleStartDatePicker"
                >
              </slot>
            </date-picker>
          </div>

          <div class="input-group col-12 mt-3">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <i class="icon-calendar-blank-outline"></i>
                <span>تاریخ پایان برنامه</span>
              </div>
            </div>
            <input
              v-show=false
              readonly="readonly"
              v-model="endDate"
              type="text"
              class="form-control"
            >
            <date-picker
              v-show=true
              :disable="disableDates"
              :auto-submit="true"
              format="jYYYY-jMM-jDD"
              @input="setDateFromDatePicker"
              ref="datePicker"
            >
              <slot>
                <input
                  :readonly=true
                  v-model="endDate"
                  class="form-control date-input"
                  @click="toggleEndDatePicker"
                >
              </slot>
            </date-picker>
          </div>

        </div>
        <!--<b-form-group-->
        <!--label="نوع مشکل"-->
        <!--label-for="name-input"-->
        <!--invalid-feedback="نوع مشکل الزامیست"-->
        <!--&gt;-->
        <!--<b-form-input-->
        <!--id="name-input"-->
        <!--v-model="name"-->
        <!--:state="nameState"-->
        <!--required-->
        <!--&gt;</b-form-input>-->
        <!--</b-form-group>-->
      </form>
    </b-modal>


    <b-modal
      id="delete-timesheet"
      ref="problemTypeModal"
      title="حذف روز کاری"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleDelete"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="input-group col-12">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <i class="icon-calendar-blank-outline"></i>
                <span>تاریخ را انتخاب کنید</span>
              </div>
            </div>
            <input
              v-show=false
              readonly="readonly"
              v-model="deleteDate"
              type="text"
              class="form-control"
            >
            <date-picker
              v-show=true
              :highlight="highlight"
              :auto-submit="true"
              format="jYYYY-jMM-jDD"
              @input="setDateFromDatePicker"
              ref="datePicker"
            >
              <slot>
                <input
                  :readonly=true
                  v-model="deleteDate"
                  class="form-control date-input"
                  @click="toggleDeleteDatePicker"
                >
              </slot>
            </date-picker>
          </div>


        </div>

      </form>
    </b-modal>


    <b-modal
      id="problemTypeDetails"
      ref="problemTypeDetail"
      title="جزئیات مشکل"
      size="lg"
      ok-title="ذخیره"
      cancel-title="بستن"
      @ok="handleOk"
      ok-only
    >
      <problem-details v-bind:problem-type="problemType"></problem-details>
    </b-modal>

  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import ShowProblemsModal from "../../components/ShowProblemsModal";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState} from "vuex";
  import ProblemDetails from "../../components/ProblemDetails.vue";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Utils from "../../_framework/utils/Utils";
  import Moment from "moment-jalali";

  export default {
    name: "timesheet",
    components: {
      VsTable,
      datePicker: DatePicker,
      Moment,
    },
    data() {
      return {
        access: {},
        timeSheets: [],
        deleteButtonState: 'primary',
        data: '',
        submittedNames: [],
        nameState: null,
        name: '',
        editProblemTypeFlag: false,
        problemType: {},
        startDate: null,
        endDate: null,
        deleteDate: null,
        dateClicked: 0,
        disableDates: [],

      };
    },
    mounted() {
      this.getTimeSheet();
    },
    methods: {

      highlight(formatted, dateMoment, checkingFor) {


        let attributes = {'title': 'بدون تعریف' + formatted};
        for (let i = 0; i < this.disableDates.length; i++) {
          if (checkingFor === 'day' && formatted === this.disableDates[i]) {
            // console.log("28")
            attributes['style'] = 'background-color: #f9e1be !important; ';
            attributes['title'] = 'این روز در تقویم کاری تعریف شده است';
          }
        }
        // if (checkingFor === 'day' && formatted === '1399-02-28'){
        //   console.log("28")
        //   attributes['style'] = 'color: #EF6C00 !important; background-color: #f9e1be !important; border: solid 1px #EF6C00;';
        //   attributes['title'] = 'جشن چهارشنبه سوری';
        // }
        // if (checkingFor === 'day' && formatted === '1399-02-29'){
        //   console.log("29")
        //   attributes['style'] = 'background-color: #e91600 !important;';
        //   attributes['title'] = 'روز ملی شدن صنعت نفت';
        // }
        // if (checkingFor === 'day' && formatted === '2020-05-08'){
        //   console.log("29")
        //   attributes['style'] = 'background-color: #e91600 !important;';
        //   attributes['title'] = 'روز ملی شدن صنعت نفت';
        // }
        return attributes;
      },
      getTimeSheet() {
        new BaseService('Time', '/GetTimeSheet').getList().then((response) => {
          this.timeSheets = response.data;
          for (let i = 0; i < this.timeSheets.length; i++) {
            // console.log(this.timeSheets[i].dateTime);
            this.timeSheets[i].jdateTime = Moment(this.timeSheets[i].dateTime.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
          }
          this.setDisable();
          // console.log(this.timeSheets);

        }).catch((error) => {
          console.log(error)
        })
      },
      setDisable() {
        this.disableDates = [];
        for (let i = 0; i < this.timeSheets.length; i++) {
          this.disableDates.push(this.timeSheets[i].jdateTime);
        }
        // console.log(this.disableDates)
      },

      onDeleteClicked(item) {
        const $btnDel = $(`#btn-delete-${item.id}`);
        if (!$btnDel.hasClass("btn-danger")) {
          $btnDel.addClass("btn-danger");
          setTimeout(() => {
            $btnDel.removeClass("btn-danger");
          }, 2000);
        } else {
          new BaseService('WorkProblems', `/DeleteProblemType/${item.id}`).delete().then((response) => {
            this.$noty.success("حذف با موفقیت انجام شد");
            this.getTimeSheet();
          }).catch((error) => {
            console.log(error)
          });
        }
      },
      createProblemType(name) {
        let createProblemType = {
          name: name
        };
        new BaseService('WorkProblems', '/CreateProblemType').create(createProblemType).then((response) => {
          this.$noty.success("ثبت با موفقیت انجام شد");
          this.getTimeSheet();
        }).catch((error) => {
          console.log(error)
        });
      },
      updateProblemType(obj) {
        let updateProblemType = {
          id: obj.id,
          name: this.name,
        };

        new BaseService('WorkProblems', '/UpdateProblemType').update(updateProblemType).then((response) => {
          this.$noty.success("تغییرات با موفقیت صورت گرفت");
          this.getTimeSheet();
          this.editProblemTypeFlag = false;
        }).catch((error) => {
          console.log(error)
        });
      },
      onShowProblemItems(item) {
        this.$refs['problemTypeDetail'].show();
        this.problemType = item;
      },
      editProblemType(item, index) {
        this.editProblemTypeFlag = true;
        this.$refs['problemTypeModal'].show();
        this.name = item.name;
        this.problemType = item

      },
      onCancelClicked() {

      },
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity();
        this.nameState = valid ? 'valid' : 'invalid';
        return valid
      },
      handleSubmit() {
        let date = Moment(this.startDate, "jYYYY/jMM/jDD");
        this.startDate = date.format("YYYY-MM-DD");
        let date2 = Moment(this.endDate, "jYYYY/jMM/jDD");
        this.endDate = date2.format("YYYY-MM-DD");
        let createTimesheet = {
          startDate: (this.startDate),
          endDate: (this.endDate)
        };
        console.log(createTimesheet);
        new BaseService('Time', '/AddTimeSheet').create(createTimesheet).then((response) => {
          this.$noty.success("ثبت با موفقیت انجام شد");
          this.getTimeSheet();
        }).catch((error) => {
          Utils.handleErrorWithNotification("" + error, this.$noty);
          console.log(error);
        });
        this.startDate = null;
        this.endDate = null;
      },
      handleOk(bvModalEvt) {
        if (this.startDate !== null && this.endDate !== null) {
          this.handleSubmit();
        }
      },
      handleDelete() {
        if (this.deleteDate !== null) {
          let date = Moment(this.deleteDate, "jYYYY/jMM/jDD");
          this.deleteDate = date.format("YYYY-MM-DD");
          let deleteTimesheet = {
            startDate: (this.deleteDate),

          };
          new BaseService('Time', '/DeleteTimeSheet').create(deleteTimesheet).then((response) => {
            this.$noty.success("حذف با موفقیت انجام شد");
            this.deleteDate = null;
            this.getTimeSheet();
          }).catch((error) => {
            Utils.handleErrorWithNotification("" + error, this.$noty);
            console.log(error);
          });
        }
      },
      resetModal() {
        this.name = '';
        this.nameState = null;
      },
      toggleStartDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },
      toggleEndDatePicker() {
        this.dateClicked = 2;
        this.$refs.datePicker.togglePicker();
      },
      toggleDeleteDatePicker() {
        this.dateClicked = 3;
        this.$refs.datePicker.togglePicker();
      },

      setDateFromDatePicker(date) {
        if (this.dateClicked === 1) {
          this.startDate = date;
        }
        if (this.dateClicked === 2) {
          this.endDate = date;
        }
        if (this.dateClicked === 3) {
          this.deleteDate = date;
        }
        // this.voucherModel.voucherDate = date;
      },
      showTimesheet(){
        this.$refs.datePicker3.togglePicker();
      },

    }
    ,
    created: () => {
    },
    /*beforeMount() {
        this.options.access = checkAccess(this.$route.path);
        //console.log(this.options.access);
        this.show = !!this.options.access;
    },*/
    computed:
      {
        ...
          mapState(["selectedRows", "currentService", "vsTableFeed"]),

      }
  }
  ;
</script>



